import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlSegment } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class Authguard {

  constructor(private authService: AuthService, private router: Router, private titleService: Title) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    const segment: UrlSegment[] = route.url;
    let canActivate = true;
    if (!this.authService.isAuthenticated() || !this.authService.validNavigationalUrl(segment[0].path)) {
      this.router.navigate(['unauthorized']);
      canActivate = false;
    }

    if (route.data["title"]) {
      this.titleService.setTitle("Applicant Form | " + route.data["title"]);
    }

    return canActivate;
  }
}
